"use client";

import { Link } from "@/i18n/navigation";

export function CaseStudyButton() {
    return (
        <Link href="/about/case-studies/university-of-birmingham">
            <div className="md:flex hidden items-center justify-between max-w-196 w-full px-3 py-2 bg-white rounded-full shadow-sm border border-gray-200 hover:shadow-md hover:scale-105 transition-all duration-300 ease-in-out">
                <div className="flex items-center gap-2 min-w-0">
                    <div className="w-1.5 h-1.5 rounded-full bg-ss-green animate-pulse shrink-0"></div>
                    <span className="text-xs font-medium text-black whitespace-nowrap">Success Story</span>
                    <div className="h-[16px] w-[2px] bg-ss-green shrink-0"></div>
                    <span className="text-xs text-black truncate">The University of Birmingham uses StudyStash's neuroscience-driven approach to boost student success</span>
                </div>
                <svg className="size-4 text-ss-green ml-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                </svg>
            </div>
        </Link>
    );
}
